import { render, staticRenderFns } from "./PasajesList.vue?vue&type=template&id=0bd1b238"
import script from "./PasajesList.vue?vue&type=script&lang=js"
export * from "./PasajesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports